import { notEmpty } from '../../utils/validator'
import addUser from '../../components/hierarchy/addUser.vue'
import editUser from '../../components/hierarchy/editUser.vue'
import store from '../../store/index'
import viewUser from '../../components/hierarchy/viewUser.vue'
import resetPass from '../../components/hierarchy/resetPass.vue'
export default {
  className: '_User',
  tableSize: 'small',
  render (record) {
    return record.username || '-'
  },
  search: [
    'nickName',
    'phone',
    'username'
  ],
  fields: [
    {
      name: 'hierarchy',
      validators: [
        notEmpty()
      ]
    },
    {
      name: 'nickName',
      validators: [
        notEmpty()
      ],
      width: 80
    },
    {
      name: 'phone',
      validators: [
        notEmpty()
      ],
      width: 120
    },
    {
      name: 'username',
      validators: [
        notEmpty()
      ]
    },
    {
      name: 'userType',
      validators: [
        notEmpty()
      ],
      width: 150
    },
    {
      name: 'status',
      validators: [
        notEmpty()
      ]
    }
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.isAdmin = { $ne: true }
      // where.hierarchy = {
      //   $inQuery: {
      //     where: {
      //       tag: {
      //         $regex: `^${store.getters.userLevelTag}`
      //       }
      //     },
      //     className: 'hierarchy'
      //   }
      // }
    }
  },
  action: {
    export: {
      icon: ''
    },
    create: {
      type: 'list',
      icon: '',
      text: '新建',
      // permission: 'create_UserModel',
      // hidden: () => !store.getters.isAdmin,
      component: addUser
    },
    view: {
      type: 'row',
      text: '查看',
      // permission: 'view_UserModel',
      hidden: () => !store.getters.isAdmin,
      component: viewUser
    },
    reset: {
      type: 'row',
      text: '重置密码',
      // permission: 'view_UserModel',
      hidden: () => !store.getters.isAdmin,
      component: resetPass
    },
    edit: {
      type: 'row',
      text: '编辑',
      // permission: 'edit_UserModel',
      hidden: () => !store.getters.isAdmin,
      component: editUser
    },
    delete: {
      type: 'row',
      text: '删除',
      // permission: 'delete_UserModel'
      hidden: () => !store.getters.isAdmin
    }
  }
}
